import {
  addDays,
  eachDayOfInterval,
  endOfMonth,
  endOfWeek,
  format,
  isWeekend,
  parseISO,
  startOfMonth,
  startOfWeek,
} from 'date-fns';

export const toKey = (day: Date) => format(day, 'yyyy-MM-dd');

export const getMonthWeeks = (month: Date) => {
  const days = eachDayOfInterval({
    start: startOfWeek(startOfMonth(month)),
    end: endOfWeek(endOfMonth(month)),
  });
  return Array.from({ length: days.length / 7 }, (_, i) => days.slice(i * 7, i * 7 + 7));
};

export const getFillDates = ({
  count,
  taken,
  after,
  skipWeekends,
}: {
  count: number;
  taken: Set<string>;
  after: Date;
  skipWeekends: boolean;
}) => {
  const out: string[] = [];
  let day = addDays(after, 1);
  for (let guard = 0; out.length < count && guard < 400; guard += 1) {
    const key = toKey(day);
    if (!taken.has(key) && !(skipWeekends && isWeekend(day))) out.push(key);
    day = addDays(day, 1);
  }
  return out;
};

export const latestDay = (keys: string[], fallback: Date) =>
  keys.reduce((latest, key) => {
    const day = parseISO(key);
    return day > latest ? day : latest;
  }, fallback);

export const getRangeKeys = (from: string, to: string, skipWeekends: boolean) => {
  const [start, end] = [parseISO(from), parseISO(to)].sort((a, b) => +a - +b);
  return eachDayOfInterval({ start, end })
    .filter((day) => !(skipWeekends && isWeekend(day)))
    .map(toKey);
};
